import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef, ComponentRef, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MyAccountService } from '../services/myAccount.service';
import { GetDebtorSummary, GetDebtorHistory } from '../models/Profile-view.model';
import { IMenu } from '../models/imenu.model';
import { ShoppingCartService } from '../services/shopping-cart.service';
import { CommonService } from '../services/common.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { HelpComponent } from '../nav/nav-components/help/help.component';
import * as type from '../shared/action.event';
import { EventListenerService } from '../services/close-listenenr.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { Promotion } from '../models/marketing.model';
import { MarketingService } from '../services/marketing.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'dashboard-compopnent',
  templateUrl: './home.page.component.html',
  styleUrls: ['./home.page.component.css']
})
export class HomePageComponent implements OnInit, OnDestroy {

  getDebtorSummary: GetDebtorSummary = new GetDebtorSummary();
  getDebtorHistory: Array<GetDebtorHistory>;
  transactionalHistoryChart: any;
  transactionalHistoryData: any;
  searchField = '';
  accountId = '';
  summaryLodingStatus: boolean = true;
  chartLoadingStatus: boolean = true;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  tourStep: string;
  searchInput: string;
  zone: string;
  postResponse: string;

  currentUserModel: CurrentUserModel;

  isAU: boolean;

  freightLoadingStatus: boolean = false

  featuredPromotionList = new Array<Promotion>();
  promotionList: Array<Promotion>;
  type = 'P';
  selectedBrandPromotionList = new Array<Promotion>();


  @ViewChild('popoverHome', { static: true}) public popover: NgbPopover;
  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb
  @ViewChild('entry', { read: ViewContainerRef })

  entry: ViewContainerRef;
  component: ComponentRef<any>;

  constructor(
    private shoppingCartService: ShoppingCartService,
    private router: Router,
    private closeListener: EventListenerService,
    private commonService: CommonService,
    private resolver: ComponentFactoryResolver,
    private activatedRouter: ActivatedRoute,
    public authService: AuthService,
    private marketingService: MarketingService,
    private myAccountService: MyAccountService
  ) {
    this.commonService.set(NgbPopover.prototype, ['_unregisterListenersFn'], function () { });
    commonService.emitUpdateSideBarActiveItem('dashboard');
  }

  quickStartMenu: IMenu[] = [
    {
      menuName: 'Catalogues',
      menuIconUrl: '../images/site-icons/catalogues-red.svg',
      menuRouter: '/catalogues'
    },
    {
      menuName: 'Subscriptions',
      menuIconUrl: '../images/site-icons/subscriptions-red.svg',
      menuRouter: '/manageSubscriptions'
    },
    {
      menuName: 'Renewals',
      menuIconUrl: '../images/site-icons/renewals-red.svg',
      menuRouter: '/manageRenewalsNew'
    },
    {
      menuName: 'Promotions',
      menuIconUrl: '../images/site-icons/promotions-red.svg',
      menuRouter: '/promotions'
    },
    {
      menuName: 'Events',
      menuIconUrl: '../images/site-icons/events-red.svg',
      menuRouter: '/events'
    }
  ];

  quickStartMenu2: IMenu[] = [
    {
      menuName: 'Customers',
      menuIconUrl: '../images/site-icons/customers-red.svg',
      menuRouter: '/customers'
    },
    {
      menuName: 'Promotions',
      menuIconUrl: '../images/site-icons/promotions-red.svg',
      menuRouter: '/promotions'
    },
    {
      menuName: 'Events',
      menuIconUrl: '../images/site-icons/events-red.svg',
      menuRouter: '/events'
    }
  ];

  accountMenu: IMenu[] = [
    {
      menuName: 'Open Orders',
      menuIconUrl: '../images/site-icons/orders-red.svg',
      menuRouter: '/myOrder/openorders'
    },
    {
      menuName: 'Recently Invoiced Orders',
      menuIconUrl: '../images/site-icons/orders-red.svg',
      menuRouter: '/myOrder/shippedorders'
    },
    {

      menuName: 'Backorder ETAs',
      menuId: 'backOrderReports',
      menuIcon: 'settingButton',
      menuIconUrl: '/images/site-icons/settingIcon-hover.svg',
      menuRouter: '/reporting/backordersreport'
    },
    // {
    //   menuName: 'Ledger',
    //   menuIconUrl: '../images/new_ui/ledger-red.png',
    //   menuRouter: '/myAccount/accountledger'
    // },
    // {
    //   menuName: 'Users',
    //   menuIconUrl: '../images/new_ui/users-red-new.png',
    //   menuRouter: '/myAccount/users'
    // }
    {
      menuName: 'Returns',
      menuIconUrl: '../images/site-icons/users-red-new.svg',
      menuRouter: '/myAccount/returns'
    }
  ];

  helpMenu: IMenu[] = [
    {
      menuName: 'Feedback',
      menuIconUrl: '../images/new_ui/feedback-red.png',
      menuRouter: '/'
    },
    {
      menuName: 'Website FAQ',
      menuIconUrl: '../images/new_ui/faq-red.png',
      menuRouter: '/kb/doc/faq'
    },
    {
      menuName: 'Take a tour',
      menuIconUrl: '../images/new_ui/take-tour.png',
      menuRouter: '/'
    }
  ];
  companyInfoMenu: IMenu[] = [
    {
      menuName: 'Company Information',
      menuIconUrl: '../images/site-icons/my-account/company-info.svg',
      menuRouter: '/myAccount/compinfo'
    },
    // {
    //   menuName: 'Delivery Locations',
    //   menuIconUrl: '../images/site-icons/my-account/delivery-add.svg',
    //   menuRouter: '/myAccount/deliverylocations'
    // },
    // {
    //   menuName: 'End-User Information',
    //   menuIconUrl: '../images/site-icons/my-account/end-user-info.svg',
    //   menuRouter: '/myAccount/enduseraddress'
    // },
  ];

  portalMenu: IMenu[] = [
    {
      menuName: 'Add New User',
      menuIconUrl: '../images/site-icons/my-account/add-new-user.svg',
      menuRouter: 'users/addusers'
    },
    {
      menuName: 'Manage Existing Users',
      menuIconUrl: '../images/site-icons/my-account/existing-user.svg',
      menuRouter: 'users'
    }
  ];

  helpMenu2: IMenu[] = [
    {
      menuName: 'Lorem',
      menuIconUrl: '../images/new_ui/feedback-red.png',
      menuRouter: '/'
    },
    {
      menuName: 'Lorem',
      menuIconUrl: '../images/new_ui/faq-red.png',
      menuRouter: '/kb/doc/faq'
    },
    {
      menuName: 'Lorem',
      menuIconUrl: '../images/new_ui/take-tour.png',
      menuRouter: '/'
    }
  ];

  ngOnInit() {
    this.tourStep = "";
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
      this.isAU = this.currentUserModel.isAU;
      this.filterQuickStartMenu();
      // this.isAU = false;
    },
      (error: any) => {
        console.info(error);
      });

    this.commonService.currentStep.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: string) => {
      this.tourStep = res;
      if (res && res == "step5") {
        this.popover?.open();
      } else {
        if (this.popover?.isOpen()) {
          this.popover?.close();
        }
      }
    },
      (error: any) => {
        console.info(error);
      });

    this.closeListener.close.subscribe(value => {
      if (value === type.SETTING_PAGE || value === type.SHOPPINGCART) {
        if (this.component) {
          this.component.destroy();
        }
        this.entry.clear();
      }
    });

    this.shoppingCartService.dashboardChanged.subscribe(aliasLogin => {
      this.chartLoadingStatus = true;
      this.summaryLodingStatus = true;

      if (this.transactionalHistoryChart) this.transactionalHistoryChart.destroy();

      //this.refreshDebtorSummary();
      //this.refreshDebtorHistoryChart();
    });

    // get promotion list
    this.promotionList = new Array<Promotion>();
    this.activatedRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }
      this.marketingService.getPromotionList(this.type).subscribe((pro: Array<Promotion>) => {
        this.promotionList = pro;
        this.selectedBrandPromotionList = pro;
        if (this.promotionList) this.featuredPromotionList = this.promotionList.filter(featured => (featured.topSpot && featured.topSpot === true));
        // this.promotionsBrands = this.promotionList.map(data => data.brand);
        this.marketingService.UpdatePromotionListAnalytics(this.featuredPromotionList.map(x => x.id), this.commonService.analyticsImpression).subscribe(value => {
          //success or error
        });
      },
        (error: any) => {
          console.info(error);
        });
    });
  }

  filterQuickStartMenu() {
    var itemToHide = ["Catalogues"]
    this.quickStartMenu = this.quickStartMenu.filter((item) => !this.currentUserModel.hideSOH || (this.currentUserModel.hideSOH && itemToHide.indexOf(item.menuName) == -1));
  }
  
  search(field: string) {
    if (field.length === 0) {
      return;
    }

    this.router.navigateByUrl('/buy?searchfield=' + field);
  }

  searchPostCode() {
    this.freightLoadingStatus = true;
    this.myAccountService.searchPostCode(this.searchInput).subscribe(response => {
      this.zone = response.zone.toString();
      if (response.zone != "Post Code not found") {
        this.postResponse = "Delivery post code  " + this.searchInput + "  is in zone  " + response.zone;
      } else if (this.searchInput == null) {
        this.postResponse = 'Please input a number';
      }
      else {
        this.postResponse = "Can not find postcode " + this.searchInput ;
      }
      this.freightLoadingStatus = false;
    })
  }

  refreshDebtorSummary() {
    this.accountId = this.commonService.readCookie('AccountId')
    this.myAccountService.getDebtorSummary(this.accountId).subscribe((result: GetDebtorSummary) => {
      this.getDebtorSummary = result;
      this.summaryLodingStatus = false;
      return;
    });
  }

  refreshDebtorHistoryChart() {
    this.accountId = this.commonService.readCookie('AccountId')
    this.getDebtorHistory = new Array<GetDebtorHistory>();
    this.myAccountService.getDebtorHistory(this.accountId).subscribe((result: Array<GetDebtorHistory>) => {
      this.getDebtorHistory = result;
      this.chartLoadingStatus = false;
      //this.drawTransactionalHistoryChart();
    });
  }

  /*drawTransactionalHistoryChart() {
    var chart = document.getElementById("chartTransactionalHistory");
    var currentMonth = new Date().getMonth();
    var currentYear = this.getDebtorHistory[0];
    var previousYear = this.getDebtorHistory[1];
    var lastPreviousYear = this.getDebtorHistory[2];
    this.transactionalHistoryData = [];
    this.transactionalHistoryData.push({
      label: currentYear.out_period,
      //data: [currentYear.out_01_jan, currentYear.out_02_feb, currentYear.out_03_mar, currentYear.out_04_apr, currentYear.out_05_may, currentYear.out_06_jun, currentYear.out_07_jul, currentYear.out_08_aug, currentYear.out_09_sep, currentYear.out_10_oct, currentYear.out_11_nov, currentYear.out_12_dec],
      data: [currentMonth >= 1 ? currentYear.out_01_jan : null,
      currentMonth >= 2 ? currentYear.out_02_feb : null,
      currentMonth >= 3 ? currentYear.out_03_mar : null,
      currentMonth >= 4 ? currentYear.out_04_apr : null,
      currentMonth >= 5 ? currentYear.out_05_may : null,
      currentMonth >= 6 ? currentYear.out_06_jun : null,
      currentMonth >= 7 ? currentYear.out_07_jul : null,
      currentMonth >= 8 ? currentYear.out_08_aug : null,
      currentMonth >= 9 ? currentYear.out_09_sep : null,
      currentMonth >= 10 ? currentYear.out_10_oct : null,
      currentMonth >= 11 ? currentYear.out_11_nov : null,
      currentMonth >= 12 ? currentYear.out_12_dec : null],
      borderColor: '#C20047',
      backgroundColor: '#C20047',
      fill: false
    });

    this.transactionalHistoryData.push({
      label: previousYear.out_period,
      data: [previousYear.out_01_jan, previousYear.out_02_feb, previousYear.out_03_mar, previousYear.out_04_apr, previousYear.out_05_may, previousYear.out_06_jun, previousYear.out_07_jul, previousYear.out_08_aug, previousYear.out_09_sep, previousYear.out_10_oct, previousYear.out_11_nov, previousYear.out_12_dec],
      borderColor: '#FFD1D1',
      backgroundColor: '#FFD1D1',
      fill: false
    });


    this.transactionalHistoryData.push({
      label: lastPreviousYear.out_period,
      data: [lastPreviousYear.out_01_jan, lastPreviousYear.out_02_feb, lastPreviousYear.out_03_mar, lastPreviousYear.out_04_apr, lastPreviousYear.out_05_may, lastPreviousYear.out_06_jun, lastPreviousYear.out_07_jul, lastPreviousYear.out_08_aug, lastPreviousYear.out_09_sep, lastPreviousYear.out_10_oct, lastPreviousYear.out_11_nov, lastPreviousYear.out_12_dec],
      borderColor: '#FFD1G9',
      backgroundColor: '#FFD1G9',
      fill: false
    });


    this.transactionalHistoryChart = new Chart(chart, {
      type: 'line',
      data: {
        labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        datasets: this.transactionalHistoryData
      },
      options: {
        responsive: true,
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem) {
              return tooltipItem.yLabel.toLocaleString();
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        legend: {
          display: true,
          position: 'right',
          labels: {
            padding: 30,
            usePointStyle: true,
          }
        },
        scales: {
          xAxes: [{
            display: true,
            gridLines: false,
            ticks: {
              padding: 7,
              fontSize: 10,
              fontStyle: 400
            }
          }],
          yAxes: [{
            display: true,
            gridLines: {
              borderDash: [4, 4]
            },
            ticks: {
              callback: function (label, index, labels) {
                return label.toLocaleString();
              },
              padding: 5,
              fontStyle: 400,
              fontSize: 10
            }
          }],
        }
      }
    });
  }*/

  changeMode(event, menuName: string) {
    if (!this.tourStep) {
      event.preventDefault();
      if (menuName.toLowerCase() == "feedback") {
        const comFactory = this.resolver.resolveComponentFactory(HelpComponent);
        this.component = this.entry.createComponent(comFactory);
      } else if (menuName.toLowerCase() == "take a tour") {
        this.commonService.monitorStepChange("step1");
      }
    }
  }

  previousTourStepFour(): void {
    this.tourStep = "";
    this.commonService.monitorStepChange("step4");
  }

  navigateTo(item: IMenu): void {
    if (!this.tourStep) {
      this.router.navigateByUrl(item.menuRouter);
    }
  }

  EndTourStep(): void {
    this.popover.close();
    this.commonService.monitorStepChange("");
    this.tourStep = "";
  }

  ngOnDestroy() {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onNavigate(id, url) {
    this.marketingService.UpdatePromotionListAnalytics(id, this.commonService.analyticsClick).subscribe(value => {
      //success or error
    });
    window.open(url, '_blank');
  }

  public hasCustomersMenu(): boolean {
    return this.authService.MENU_SECTION_1.findIndex(i => i.menuId === 'customers') > 0;
  }
}
